module.exports = __webpack_public_path__ + "819e7aca.jpg";